module.exports = __webpack_public_path__ + "static/Logo_ShapYa_Red-8d94e08ca2c6b994bd6d71d0dd337f88.png";